<div>
    <strong>Enabled :</strong>
    <span class="ml-2">{{ _info?.enabled }}</span>
</div>
<div>
    <strong>Timeout :</strong>
    <span class="ml-2">{{ _info?.timeout }} minutes</span>
</div>